import { render, staticRenderFns } from "./ShippingCalculatorPage.vue?vue&type=template&id=472b1348&scoped=true"
import script from "./ShippingCalculatorPage.vue?vue&type=script&lang=js"
export * from "./ShippingCalculatorPage.vue?vue&type=script&lang=js"
import style0 from "./ShippingCalculatorPage.vue?vue&type=style&index=0&id=472b1348&prod&scoped=true&lang=css"
import style1 from "./ShippingCalculatorPage.vue?vue&type=style&index=1&id=472b1348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472b1348",
  null
  
)

export default component.exports